import React from 'react';
import { Link } from 'react-router-dom';
import { logout } from '../../../store/api/calls';
import '../../../styles/base_template.scss';
import SETTINGS from '../../../settings';

import { clearCampaignAggCache } from '../../../store/actions';

export default class sideNav extends React.Component {
  navigateAway = (path) => {
    const baseURL = SETTINGS.baseLegacyUrl;
    window.location = baseURL + path;
  };

  render() {
    return (
      <aside className="flx__nav">
        <div className="nav-title-navbar">
          <div className="nav-title-logo-bak-navbar"></div>
          <div className="nav-title-logo-navbar no-select">
            <img src={"/logo-full192.png"} alt={"ElecTrek"} className={'shadow-sharp'} />
          </div>
        </div>
        <div className="nav-body-navbar">
          <div className="media-lg">
            <Link to="/">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname.includes('/dash') ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>DASHBOARD</div>
                <div className="nav-item-icon">
                  <i className="fas fa-home"></i>
                </div>
              </div>
            </Link>

            <Link to="/site">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/site' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>SITES</div>
                <div className="nav-item-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
              </div>
            </Link>
            {this.props.showAdmin ? (
              <Link to="/script">
                <div
                  className={`nav-item main-nav-item noselect ${
                    this.props.location.pathname === '/script' ? 'focused' : ''
                  }`}
                >
                  <div className={`nav-item-label `}>SCRIPTS</div>
                  <div className="nav-item-icon">
                    <i className="fas fa-sitemap"></i>
                  </div>
                </div>
              </Link>
            ) : null}
            <Link to="/canvasser">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/canvasser' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>CANVASSERS</div>
                <div className="nav-item-icon">
                  <i className="fas fa-users ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/sitecanvass">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname.includes('/sitecanvass') ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>SITE CANVASSES</div>
                <div className="nav-item-icon">
                  <i className="fas fa-walking ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/doorcanvass">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname.includes('/doorcanvass') ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>DOOR CANVASSES</div>
                <div className="nav-item-icon">
                  <i className="fas fa-door-open ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/map" onClick={clearCampaignAggCache}>
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/map' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>TRACKING</div>
                <div className="nav-item-icon">
                  <i className="fas fa-flag-checkered ''"></i>
                </div>
              </div>
            </Link>
            <Link to="/map-report">
              <div
                className={`nav-item main-nav-item noselect ${
                  this.props.location.pathname === '/map-report' ? 'focused' : ''
                }`}
              >
                <div className={`nav-item-label`}>MAP REPORTS</div>
                <div className="nav-item-icon">
                  <i className="fas fa-map-marked"></i>
                </div>
              </div>
            </Link>
            {this.props.showAdmin ? (
              <Link to="/admin">
                <div
                  className={`nav-item main-nav-item noselect ${
                    this.props.location.pathname === '/admin' ? 'focused' : ''
                  }`}
                >
                  <div className={`nav-item-label`}>ADMIN</div>
                  <div className="nav-item-icon">
                    <i className="fas fa-cog ''"></i>
                  </div>
                </div>
              </Link>
            ) : null}
            <Link to="/login" onClick={logout}>
              <div className={`nav-item main-nav-item noselect`}>
                <div className={`nav-item-label`}>LOGOUT</div>
                <div className="nav-item-icon">
                  <i className="fas fa-sign-out-alt"></i>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </aside>
    );
  }
}
